'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = AccountRecovery;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _uiComponents = require('@wh/ui-components');

var _constants = require('./../constants');

require('./account-recovery.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Account recovery link component
 * @param {Function} t Translation function
 * @param {Function} trackingEvent Action to track events
 * @param {Function} accountRecoveryClicked Action to be called on account recovery button click
 * @returns {Element} React element
 * @constructor
 */
function AccountRecovery(_ref) {
    var t = _ref.t,
        trackingEvent = _ref.trackingEvent,
        accountRecoveryClicked = _ref.accountRecoveryClicked;

    var openAccountRecovery = function openAccountRecovery() {
        trackingEvent(_constants.TRACKING_EVENT_NAME_FORM_INTERACT, {
            formFieldName: 'forgotPasswordClicked'
        });

        accountRecoveryClicked();
    };

    return (0, _jsx3.default)('div', {
        className: 'c-login-form__account-recovery'
    }, void 0, (0, _jsx3.default)(_uiComponents.Link, {
        href: '#',
        className: 'c-login-form__account-recovery-link'
    }, void 0, (0, _jsx3.default)('span', {
        onClick: openAccountRecovery
    }, void 0, t('login')('modalForgotPassword'))));
}
//# sourceMappingURL=account-recovery.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/account-recovery/account-recovery.js
// module id = 473
// module chunks = 0